/**
 * Created by admin on 2018/5/22.
 */
import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { Input, Modal, Spin, Table } from 'antd';
import IconTip from '../IconTip';
import { ROLES_KEY } from '../../utils/constants';
import './AddRoleUser.less';
import { Btn } from '../Widgets';
import { FormattedMessage, injectIntl } from 'react-intl';

class AddRoleUser extends PureComponent {
  static defaultProps = {
    visible: false,
    searchUsers: [],
    searchUsersPagi: {}
  };

  constructor() {
    super();
    this.state = {
      selectedUsers: [],
      name: '',
      position: '',
      loading: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.visible && nextProps.visible) {
      const { dispatch } = this.props;
      dispatch({
        type: 'role/updateSearchUsersPagi',
        payload: { current: 1 }
      });
      this.searchUsers();
    }
  }

  render() {
    const {
      visible,
      searchUsers,
      searchUsersPagi,
      dispatch,
      allRoles,
      intl
    } = this.props;
    const { name, position } = this.state;
    return (
      <Modal
        visible={visible}
        title={intl.formatMessage({ id: 'meeting_dept_user_add' })}
        onCancel={this.close}
        wrapClassName="add-role-user-wrapper modal-close-header"
        footer={
          <div className="add-footer">
            <Btn onClick={this.close}>
              <FormattedMessage id="dialog_btn_cancel" />
            </Btn>
            <Btn primary onClick={this.addUser}>
              <FormattedMessage id="dialog_btn_ok" />
            </Btn>
          </div>
        }
        width={1024}
      >
        <Spin spinning={this.state.loading}>
          <div className="content">
            <div className="up">
              <div className="search-item">
                <span className="prefix">
                  <FormattedMessage id="index_username" />：
                </span>
                <Input
                  value={name}
                  onChange={e => {
                    dispatch({
                      type: 'role/updateSearchUsersPagi',
                      payload: { current: 1 }
                    });
                    this.setState({ name: e.target.value }, null);
                  }}
                />
              </div>
              <div className="search-item">
                <span className="prefix">
                  <FormattedMessage id="user_position" />：
                </span>
                <Input
                  value={position}
                  onChange={e => {
                    dispatch({
                      type: 'role/updateSearchUsersPagi',
                      payload: { current: 1 }
                    });
                    this.setState({ position: e.target.value }, null);
                  }}
                />
              </div>
              <div className="search-btn">
                <Btn
                  primary
                  height={'30px'}
                  onClick={() => {
                    this.searchUsers();
                  }}
                >
                  <FormattedMessage id="index_search" />
                </Btn>
              </div>
            </div>
            <div className="down">
              <Table
                columns={[
                  {
                    title: intl.formatMessage({ id: 'index_username' }),
                    key: 'name',
                    width: '25%',
                    render: (text, record) => {
                      const role = allRoles.find(r => r.id === record.roleId);
                      const tooltip =
                        record.roleKey !== ROLES_KEY.normal ? (
                          <IconTip title={role && role.name} type="role" />
                        ) : null;
                      return (
                        <span>
                          {record.displayName}
                          {tooltip}
                        </span>
                      );
                    }
                  },
                  {
                    title: intl.formatMessage({ id: 'index_company' }),
                    key: 'company',
                    width: '25%',
                    dataIndex: 'company'
                  },
                  {
                    title: intl.formatMessage({ id: 'user_department' }),
                    key: 'dept',
                    width: '25%',
                    dataIndex: 'dept'
                  },
                  {
                    title: intl.formatMessage({ id: 'user_position' }),
                    key: 'position',
                    width: '25%',
                    dataIndex: 'position'
                  }
                ]}
                dataSource={searchUsers}
                rowKey={record => record.userId}
                pagination={{
                  ...searchUsersPagi,
                  onChange: (page, pageSize) => {
                    dispatch({
                      type: 'role/updateSearchUsersPagi',
                      payload: { current: page, pageSize }
                    });
                    this.searchUsers();
                  }
                }}
                rowSelection={this.getRowSelection()}
              />
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }

  searchUsers = () => {
    this.setState({ loading: true });
    const { name, position } = this.state;
    const { dispatch } = this.props;
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'role/searchRoleUsers',
        name,
        position,
        resolve,
        reject
      });
    });
    promise.then(
      () => {
        this.setState({ selectedUsers: [] });
        this.setState({ loading: false });
      },
      msg => {
        Modal.error({ content: msg });
        this.setState({ loading: false });
      }
    );
  };

  addUser = () => {
    const { onCancel, dispatch, editRole } = this.props;
    const { selectedUsers = [] } = this.state;
    if (selectedUsers.length > 0) {
      const userIdArr = [];
      selectedUsers.map(user => userIdArr.push(user.userId));
      const promise = new Promise((resolve, reject) => {
        dispatch({
          type: 'role/addRoleUsers',
          roleId: editRole.id,
          userIds: userIdArr.join(';'),
          resolve,
          reject
        });
      });
      promise.then(
        () => {
          Modal.success({
            content: this.props.intl.formatMessage({
              id: 'role_manage_add_user_success'
            }),
            okText: this.props.intl.formatMessage({ id: 'dialog_btn_ok' }),
            onOk: () => {
              this.setState({ selectedUsers: [] });
              dispatch({ type: 'role/update', payload: { searchUsers: [] } });
              onCancel && onCancel();
            }
          });
        },
        msg => {
          Modal.error({ content: msg });
        }
      );
    } else {
      Modal.error({
        content: this.props.intl.formatMessage({
          id: 'role_manage_add_user_pls'
        })
      });
    }
  };

  close = () => {
    const { onCancel, dispatch } = this.props;
    this.setState({
      name: '',
      position: '',
      selectedUsers: [],
    });
    dispatch({ type: 'role/update', payload: { searchUsers: [] } });
    onCancel && onCancel();
  };

  getRowSelection() {
    const selectedRowKeys = [];
    const { selectedUsers = [] } = this.state;
    selectedUsers.every(u => selectedRowKeys.push(u.userId));
    return {
      type: 'checkbox',
      getCheckboxProps: record => {
        if (record.roleKey !== ROLES_KEY.normal) {
          return { disabled: true };
        } else {
          return { disabled: false };
        }
      },
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedUsers: selectedRows });
      },
      selectedRowKeys
    };
  }
}

const mapStateToProps = state => {
  return {
    searchUsers: state.role.searchUsers,
    searchUsersPagi: state.role.searchUsersPagi,
    allRoles: state.role.roleMenus
  };
};

export default connect(mapStateToProps)(injectIntl(AddRoleUser));



// WEBPACK FOOTER //
// ./src/components/account/AddRoleUser.js